var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 273,
    viewBox: "0 0 289 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    y: 0.707031,
    width: 288.015,
    height: 271.598,
    rx: 16,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9404,
    y: 11.6836,
    width: 266.01,
    height: 137.698,
    rx: 8,
    fill: "#E7E7E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9238,
    y: 110.191,
    width: 79.807,
    height: 31.2612,
    rx: 4,
    fill: "#F5F5F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9414,
    y: 161.059,
    width: 109.776,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9414,
    y: 232.18,
    width: 109.776,
    height: 27.2743,
    rx: 8,
    fill: "#E7E7E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 167.176,
    y: 232.18,
    width: 109.776,
    height: 27.2743,
    rx: 8,
    fill: "#E7E7E7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9414,
    y: 178.043,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 199.021,
    y: 161.059,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 199.021,
    y: 178.043,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 199.021,
    y: 195.027,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9414,
    y: 195.027,
    width: 77.9302,
    height: 8.49224,
    rx: 4,
    fill: "#E7E7E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilter);
export default __webpack_public_path__ + "static/media/emptyFilter.9386319733bf6e721e3692d7060da3ed.svg";
export { ForwardRef as ReactComponent };